import React, { useState, useEffect } from 'react';
import Icon from '@app/components/shared/icon.component';
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Button,
	CircularProgress,
	Grid,
	Hidden,
	Typography,
} from '@material-ui/core';
import { IntlService } from '@app/services/intl.service';
import Injector from '@app/services';
import { AdminCarrierService } from '@app/services/admin-carrier.service';
import { ISnackBarFeature } from '@app/models';
import { SharedService } from '@app/services/shared.service';
import { SnackBarVariants } from '@app/app.enum';
import { FormattedDate } from 'react-intl';
import { dateTimeFormatOptions } from '@app/constants';

interface IUSPSeVSRefreshInductAccordionProps extends ISnackBarFeature {}

const intlService: IntlService = Injector.get(IntlService);
const adminCarrierService: AdminCarrierService = Injector.get(AdminCarrierService);
const sharedService: SharedService = Injector.get(SharedService);

const USPSeVSRefreshInductAccordion: React.FunctionComponent<IUSPSeVSRefreshInductAccordionProps> = (props) => {
	const [lastRefresehedDate, setLastRefresehedDate] = useState<Date>(null);
	const [loading, setLoading] = useState<boolean>(false);

	useEffect(() => {
		// Show loader when fetching first time
		getLastRefreshDate(true);
	}, []);

	const getLastRefreshDate = async (showLoader = false) => {
		if (showLoader) {
			setLoading(true);
		}
		return adminCarrierService
			.GetEntryFailityZipMappingRefreshedDate()
			.then((data) => {
				setLastRefresehedDate(data.lastRefreshedDate);
				if (showLoader) {
					setLoading(false);
				}
			})
			.catch((err) => {
				if (showLoader) {
					setLoading(false);
				}
				props.openSnackBar(sharedService.parseError(err.data), SnackBarVariants.Error);
			});
	};

	const refreshInductCache = async () => {
		try {
			await adminCarrierService.RefreshEntryFacilityZipMapping();
			await getLastRefreshDate(); // Fetch date without showing loader
			props.openSnackBar(intlService.GetFormattedMessage('app.snackbar.induct-mapping-refresh-successful'));
		} catch (err) {
			props.openSnackBar(sharedService.parseError(err.data), SnackBarVariants.Error);
		}
	};

	const RefreshButton = (
		<Button color='secondary' onClick={refreshInductCache}>
			{intlService.GetFormattedMessage('app.admin.carrier-refresh-induct-mapping-button')}
		</Button>
	);

	return (
		<Accordion>
			<AccordionSummary expandIcon={<Icon name='chevron-down' />}>
				<Grid container={true} direction='row' justifyContent='space-evenly'>
					<Grid item={true} xs={12}>
						<Typography variant='h6' color='inherit'>
							{intlService.GetFormattedMessage('app.admin.carrier-details-induct-mapping')}
						</Typography>
					</Grid>
				</Grid>
			</AccordionSummary>
			<AccordionDetails style={{ maxHeight: '186px !important' }}>
				<Grid container={true} justifyContent='center'>
					{loading ? (
						<CircularProgress color='secondary' />
					) : (
						<Grid container={true} direction='row' justifyContent='space-evenly' alignItems='center' spacing={2}>
							<Grid item={true} xs={5} md={2} lg={3}>
								<Typography variant='subtitle2' color='inherit'>
									{intlService.GetFormattedMessage('app.admin.carrier-details-last-refreshed-date')}
								</Typography>
							</Grid>
							<Grid container={true} item={true} alignItems='center' xs={7} md={10} lg={9}>
								<Typography variant='subtitle2' color='inherit' className='mr-3'>
									{lastRefresehedDate !== null ? (
										<FormattedDate {...dateTimeFormatOptions} value={lastRefresehedDate} />
									) : (
										intlService.GetFormattedMessage('app.common.not-applicable-value')
									)}
								</Typography>
								<Hidden xsDown={true}>{RefreshButton}</Hidden>
							</Grid>
							<Hidden smUp={true} mdDown={false}>
								<Grid container={true} alignItems='center' justifyContent='center' className='mt-2 mb-2'>
									{RefreshButton}
								</Grid>
							</Hidden>
						</Grid>
					)}
				</Grid>
			</AccordionDetails>
		</Accordion>
	);
};

export default USPSeVSRefreshInductAccordion;



// WEBPACK FOOTER //
// ./src/components/admin/setting/usps-evs-refresh-induct-accordion.component.tsx